<template lang="pug">
div(:key="mixinRerenderTrigger")
  redesign-list-dialog(
    v-model="showDialog"
    :title="event.short_name"
    :caption="event.target"
    :tabs="tabsFilters"
    :selected-tab.sync="filters.selected"
    :method="getMyEventRequests"
    :serializeData="serializeRequestData"
  )
  redesign-confirm-dialog(
    v-model="confirm.dialog"
    cancel-text="Оставить"
    accept-text="Отменить"
    result-icon="$iclose-outline-circle"
    result-icon-color="redesignError"
    result-button-text="Перейти к заявкам"
    :message="`Вы действительно хотите отменить заявку ${nominationsTitleText[requests.target]}?`"
    :result-message="`Вы отменили заявку ${nominationsTitleText[requests.target]}`"
    :cancel-handler="closeDialog"
    :accept-handler="accept"
  )
</template>

<script>
import RedesignListDialog from '@/components/user-redesign/dialogs/RedesignListDialog.vue';
import RedesignDialog from '@/components/user-redesign/dialogs/RedesignDialog.vue';
import RedesignConfirmDialog from '@/components/user-redesign/dialogs/RedesignConfirmDialog.vue';
import AppTabsGroup from '@/components/user-redesign/controls/AppTabsGroup.vue';
import DataList from '@/components/user-redesign/DataList.vue';
import mixinForceRerender from '@/mixins/mixinForceRerender';

const STATUS_FILTERS = [
  {
    text: 'Все заявки',
    value: 'all',
  },
  {
    text: 'Принятые',
    value: 3,
  },
  {
    text: 'На рассмотрении',
    value: 1,
  },
  {
    text: 'Можно подать',
    value: 'aviable',
  },
];

export default {
  name: 'EventRequestDialog',
  components: {
    RedesignDialog,
    AppTabsGroup,
    DataList,
    RedesignConfirmDialog,
    RedesignListDialog,
  },
  mixins: [mixinForceRerender],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        count: 5,
      },
      requests: {
        target: null,
      },
      confirm: {
        dialog: false,
      },
      filters: {
        all: STATUS_FILTERS,
        selected: null,
      },
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    tabsFilters() {
      const { STATUS_ACTIVE, STATUS_REQUEST, STATUS_REJECT } = this.$conf.EVENT_USER_STATUS;

      return [
        {
          text: 'Все заявки',
          value: 'all',
        },
        {
          text: 'Принятые',
          value: 'active',
          filters: {
            'search[status]': STATUS_ACTIVE,
          },
        },
        {
          text: 'На рассмотрении',
          value: 'request',
          filters: {
            'search[status]': STATUS_REQUEST,
          },
        },
        {
          text: 'Отклоненные',
          value: 'rejected',
          filters: {
            'search[status]': STATUS_REJECT,
          },
        },
      ];
    },
    nominationEntityName() {
      const { frontend_params } = this.event.options || {};

      return frontend_params?.getEntityName('nominations_override', 2) || 'номинации';
    },
    nominationsNames() {
      return (this.event?.nominations || []).reduce((acc, { id, name }) => {
        acc[id] = name;

        return acc;
      }, {});
    },
    nominationsTitleText() {
      const { nominationsNames, nominationEntityName } = this;

      return Object.fromEntries(Object.entries(nominationsNames).map(([key, value]) => [key, `для ${nominationEntityName} «${value}»`]));
    },
  },
  created() {},
  methods: {
    closeDialog() {
      this.confirm.dialog = false;
    },
    async getMyEventRequests(paramsInitial) {
      const params = {
        ...paramsInitial,
        'search[event_id]': this.event.id,
      };

      return this.$api.user.getUserEventRequests(params);
    },
    accept() {
      const { id } = this.event;
      const { target } = this.requests;
      const params = {
        nomination_ids: [target],
      };

      return this.$api.events.unregisterCertificate(id, params).then(() => {
        this.closeDialog();
        this.mixinForceRerender();
      });
    },
    serializeRequestData(data) {
      return data.map(({ status, nomination_id }) => {
        const { STATUS_ACTIVE, STATUS_REQUEST, STATUS_REJECT, STATUS_DRAFT_REQUEST, STATUS_INCORRECT_DOCUMENTS } =
          this.$conf.EVENT_USER_STATUS;
        const templatesByStatus = {
          [STATUS_ACTIVE]: {
            title: (nomination) => `Ваша заявка ${nomination} принята`,
            icon: '$icheck-outline-circle',
            color: 'redesignSuccess',
            action: {
              text: 'Отменить заявку',
              onClick: (nomination) => {
                this.requests.target = nomination;
                this.confirm.dialog = true;
              },
            },
          },
          [STATUS_REJECT]: {
            title: (nomination) => `Ваша заявка ${nomination} отклонена`,
            icon: '$iclose-outline-circle',
            color: 'redesignError',
            action: {
              text: 'Отменить заявку',
              onClick: (nomination) => {
                this.requests.target = nomination;
                this.confirm.dialog = true;
              },
            },
          },
          [STATUS_REQUEST]: {
            title: (nomination) => `Ваша заявка ${nomination} на рассмотрении`,
            icon: '$iclock-outline',
            color: 'redesignWarning',
            action: {
              text: 'Отменить заявку',
              onClick: (nomination) => {
                this.requests.target = nomination;
                this.confirm.dialog = true;
              },
            },
          },
          [STATUS_INCORRECT_DOCUMENTS]: {
            title: (nomination) => `Вашу заявку ${nomination} необходимо дозаполнить`,
            icon: '$iinfo',
            color: 'redesignSecondary',
            action: {
              text: 'Перейти к заявке',
              onClick: () => {
                this.$router.push(`/event/register/${this.event.id}`);
              },
            },
          },
          [STATUS_DRAFT_REQUEST]: {
            title: (nomination) => `Ваша заявка в номинации «${nomination}» не заполнена`,
            icon: '$iclock-outline',
            color: 'redesignSecondary',
            action: {
              text: 'Перейти к заявке',
              onClick: () => {
                this.$router.push(`/event/register/${this.event.id}`);
              },
            },
          },
        };

        const template = templatesByStatus[status];
        if (!template) {
          return null;
        }

        const { title, color, icon, action } = template;

        return {
          title: {
            main: title(this.nominationsTitleText[nomination_id]),
          },
          icon: {
            color,
            icon,
          },
          action: {
            ...action,
            onClick: () => action.onClick(nomination_id),
          },
        };
      });
    },
  },
};
</script>
